export function formatDate(languageCode: string, date?: Date): string {
    if (date) {
        const dateToFormat = new Date(date);
        const options = { year: 'numeric' as const, month: 'numeric' as const, day: 'numeric' as const };
        if (languageCode === 'nl') {
            const formatter = new Intl.DateTimeFormat('nl-NL', options);
            return formatter.format(dateToFormat);
        }
        const formatter = new Intl.DateTimeFormat('en-US', options);
        return formatter.format(dateToFormat);
    }
    return '';
}
